<div mat-dialog-title>
  <div class="titulo-onboarding">
    @if(step == 1){
      ¿Qué es la sincronización?
    }@else if(step == 2){
      requisitos para sincronizar tu empresa
    }@else if(step == 3){
      ventajas de la vinculación con el SII
    }@else if(step == 4){
      consejos para evitar errores<br>con la clave SII de tu empresa
    }@else if(step == 5){
      ¿Qué es un sistema de facturación?
    }@else if(step == 6){
      ¿Qué es una operación de factoring?
    }@else if(step == 7){
      Financia tu empresa con seguridad y confianza
    }@else if(step == 8){
      la clave que ingresaste no está asociada al perfil de tu empresa en el <span style="text-transform: uppercase; cursor: default; color: var(--color-primary); text-decoration: none;">SII</span>
    }@else if(step == 9){
      la clave <span style="text-transform: uppercase; cursor: default; color: var(--color-primary); text-decoration: none;">SII</span> ingresada no es válida
    }@else if(step == 10){
      facturas con preaprobación
    }@else if(step == 11){
      ¡importante!
    }@else if(step == 12){
      <div style="font-size: 45px;"><i class="fa-sharp fa-regular fa-circle-info"></i></div>
     revisa tu lista de clientes calificados
    }@else if (step == 13) {
      ¿Qué es el PIN de firma segura?
    }@else if (step == 14) {
      ¿Por qué es necesario activar la geolocalización para firmar documentos?
    }@else if (step == 15) {
      ¿Por qué es necesario crear el PIN de firma?
    }@else if (step == 16) {
      consejos para proteger tu PIN de firma
    }@else if (step == 17) {
      resumen de tu primera operación en Simpli
    }@else if (step == 18) {
      facturas preaprobadas
    }@else if (step == 19) {
      ceder por la plataforma para clientes
    }@else if (step == 20) {
      ceder por un sistema externo
    }@else if (step == 21) {
      ceder por AEC
    }@else if (step == 22) {
      revisa la descripción de los documentos que debes cargar
    }@else if (step == 23) {
      descubre dónde solicitar la escritura de constitución de tu empresa
    }@else if (step == 24) {
      ¿Qué significa protocolizar un documento?
    }@else if (step == 25) {
      ¡importante!
    }@else if (step == 26) {
      ¿Por qué es necesaria la última versión de los documentos?
    }@else if (step == 27) {
      estás a punto de cambiar de aval
    }@else if (step == 28) {
      ¡Importante!
    }@else if (step == 29) {
      ingresa los datos de contacto de <span style="text-transform: capitalize; cursor: default; color: var(--color-primary); text-decoration: none;">{{firmanteName}}</span>
    }@else if (step == 30) {
      ¿Por qué es necesaria la firma de un cónyuge?
    }@else if (step == 31) {
      ¿Qué es una simulación de factoring?
    }@else if (step == 32) {
      conoce la documentación que deberá ser firmada junto con el contrato
    }@else if (step == 33) {
      ¿Qué es el set legal de Poderes Bancarios?
    }
    @else if (step == 90) {
     Tu empresa ya está registrada
    }



    <div  mat-dialog-close class="close-dialog-icon"><i class="fa-sharp fa-regular fa-xmark"></i></div>
  </div>
  <div class="subtitulo-onboarding">
    @if(step == 2){
      Selecciona el encabezado del requisito para acceder a su descripción completa.
    }@else if(step == 3){
      Al ingresar la clave SII de tu empresa, podrás acceder a evaluaciones más ágiles,<br>además de contar con todos los beneficios de la sincronización.
    }@else if(step == 7){
      Conoce nuestra <strong>política de privacidad de datos</strong>.
    }@else if(step == 9){
      Por ahora, pausaremos los intentos de ingresar la clave para <strong>evitar que el SII bloquee tu acceso</strong>.
    }@else if(step == 12){
      Antes de continuar, revisa quiénes de tus clientes calificaron<br>para una operación de factoring inmediata.
    }@else if (step == 29){
      Necesitamos que completes todos los campos solicitados.
    }



    @else if(step == 20){
      error<br>aqui
    }
  </div>
</div>

<div mat-dialog-content>


  @if(step == 1){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container">
      Es una función que <strong>vincula los datos de tu empresa</strong> con esta plataforma, para que así puedas monitorear el <strong>progreso de tu negocio</strong> en tiempo real.
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if(step == 2){
    <div class="contenedor-expansion">
      <mat-accordion class="example-headers-align">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Ingresa la clave SII de tu empresa </mat-panel-title>
          </mat-expansion-panel-header>
  

          <div class="texto-expansion">
            Con este dato podemos vincularnos al SII para agilizar evaluaciones, ofrecerte opciones de financiamiento y generar tu Dashboard contable.
          </div>


        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Indicar cuál es el sistema de facturación que usas </mat-panel-title>
          </mat-expansion-panel-header>
  

          <div class="texto-expansion">
            Si ya estás emitiendo tus facturas a través de MiPyme, podemos ayudarte a simplificar la gestión de tus documentos tributarios. Con tu autorización para recibir las facturas directamente desde MiPyme, nos aseguramos de que toda tu información esté organizada y siempre disponible para tu negocio.
          </div>


        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if(step == 3){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
      <div class="swiper-container">

        <div class="titulo-onboarding" style="text-align: left;font-size: 26px;margin-bottom: 20px;">
          Beneficios de la sincronización:
        </div>

        <swiper-container id="swiper" #swiper 
        speed="500" autoplay="true" css-mode="false" loop="true"
        navigation="false" pagination="true" scrollbar="false" virtual="false" pagination-clickable="true">


          <swiper-slide>

            <div class="row">

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="swipper-content">
                  <div>
                    <img src="../../../assets/iconografia/swiper1.svg" />
                  </div>
                  <div>
                    Accede a tu dashboard<br>contable
                  </div>
  
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="swipper-content">
                  <div>
                    <img src="../../../assets/iconografia/swiper2.svg" />
                  </div>
                  <div>
                    Indentifica a tus<br>principales clientes
                  </div>

                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="swipper-content">
                  <div>
                    <img src="../../../assets/iconografia/swiper3.svg" />
                  </div>
                  <div>
                    Consulta el DICOM de<br>tu empresa
                  </div>
  
                </div>
              </div>

            </div>
  

          </swiper-slide>


          <swiper-slide>

            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="swipper-content">
                  <div>
                    <img src="../../../assets/iconografia/swiper4.svg" />
                  </div>
                  <div>
                    Revisa tus facturas<br>pagadas
                  </div>
  
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="swipper-content">
                  <div>
                    <img src="../../../assets/iconografia/swiper5.svg" />
                  </div>
                  <div>
                    Gestiona tus<br>proveedores
                  </div>
  
                </div>
              </div>
            </div>


  

          </swiper-slide>





        </swiper-container>
      </div>




    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 4){
    <div class="image-container">
      <img src="../../../assets/iconografia/evitar_errores.svg" />
    </div>
  
    <div class="label-container">
      <ul>
        <li>Asegúrate de ingresar la clave de acceso al SII asociada al<br><strong>RUT de tu empresa</strong>.</li>
        <li>Para evitar que la clave sea bloqueada, <strong>no intentes ingresarla<br>más de 2 veces</strong>.</li>
        <li>Si no tienes seguridad de cuál es la clave, trata de <span (click)="ingresar_al_sii()">ingresar al SII</span> para validarla,<br> sin superar los 2 intentos recomendados.</li>
      </ul>  
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 5){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container">
      Son softwares o plataformas que permiten <strong>emitir, ceder o realizar otras operaciones</strong> con facturas electrónicas, respetando la normativa legal vigente.

      <br><br>
      Para más información, <a href="https://api.whatsapp.com/send/?phone=%2B56934677786&text&type=phone_number&app_absent=0" target="_blank">contacta a nuestro equipo de experiencia cliente</a>.
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 6){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container">
      Es un proceso que <strong>otorga liquidez</strong> a través de la cesión de cuentas por cobrar, como facturas con pago a crédito.

      <br><br>
      En resumen, <strong>nos cedes tus facturas</strong>, te entregamos la liquidez y gestionamos la cobranza con el deudor (tu cliente).
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 7){
    <div class="imagen-container">
      <video width="370" height="240" controls muted poster="https://simpliassets12daacw.s3.us-east-2.amazonaws.com/loader-video.jpg">
        <source src="https://simpliassets12daacw.s3.us-east-2.amazonaws.com/politica_privacidad_simpli.mp4"
          type="video/mp4">
        Tu navegador no soporta el tag de video.
      </video>
    </div>

    <contact-container></contact-container>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close (click)="continue()">Continuar</button>
    </div>
  } @else if (step == 8){
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - clave sii(1).svg" />
    </div>
  
    <div class="label-container">
      <ul>
        <li>Si superas los 3 intentos al ingresar tu clave, el SII bloqueará tu acceso. Para evitar esto, tendrás <strong>solo un intento más</strong>.</li>
        <li>Al reintentarlo, asegúrate de ingresar la <strong>clave SII asociada al RUT de tu empresa</strong>.</li>
      </ul>  
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" (click)="reintentar()">Reintentar</button>
    </div>
  }@else if (step == 9){
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - clave sii(2).svg" />
    </div>
  
    <div class="label-container">
      <div class="box-info2">
        Para mayor seguridad, continúa tu sincronización con la ayuda de nuestro <strong>equipo de experiencia del cliente</strong>.
      </div>
    </div>

  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" (click)="ir_a_ux()">Contactar con experiencia del cliente</button>
      <button mat-stroked-button class="secondary-button" mat-dialog-close>Cerrar</button>
    </div>
  }@else if (step == 10){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container" style="text-align: center;">
      Son facturas que evaluamos por adelantado tras vincularnos con tu perfil en el SII. Esto nos permite <strong style="font-weight: bold;">ofrecerte una opción de factoring inicial, personalizada e inmediata.</strong>
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if(step == 11){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container">
      Las facturas que estás a punto de agregar serán evaluadas por nuestro equipo. Una vez aprobadas, podrás comenzar a operar.
    </div>
  
    <div class="caja-botones">
      <button mat-stroked-button class="secondary-button" mat-dialog-close>Volver</button>
      <button mat-stroked-button class="primary-button" (click)="continuar_agregar()">Continuar</button>
    </div>
  }@else if (step == 12){

 
      @if(loading_deudores){
        <loading-interno></loading-interno>
      }@else{
        <div class="caja-deudores add_factoring">
          <table>
            <thead>
                <tr>
                    <th>Deudor (tu cliente)</th>
                    <th>RUT</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of deudores">
                    <td>{{i.nombre_deudor}}</td>
                    <td>{{i.rut_deudor}}</td>
                </tr>
            </tbody>
          </table> 
        </div>

      }

        <contact-container [tittle]="'Si tienes preguntas, contacta a tu ejecutivo.'"></contact-container>
  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" (click)="continue_six()">Continuar</button>
    </div>
  }@else if (step == 13) {
    <div class="image-container">
      <img src="../../../assets/iconografia/facturador.svg" />
    </div>
  
    <div class="label-container" style="text-align: center;">
      Es una <strong>clave de seguridad</strong> de 4 dígitos que debes crear para firmar documentos en la plataforma. Su función es evitar que personas no autorizadas utilicen tu firma electrónica. 
      <br><br>
      El PIN es <strong>personal e intransferible</strong> y deberás ingresarlo cada vez que necesites firmar un documento.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 14) {
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - geolocalizacion.png" />
    </div>
  
    <div class="label-container" style="text-align: center;">
      Es un protocolo que la notaría solicita para validar una firma electrónica. <strong>No expondremos ni compartiremos</strong> tu ubicación; solo necesitamos comprobar que estás en territorio nacional.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 15) {
    <div class="image-container">
      <img src="../../../assets/iconografia/facturador.svg" />
    </div>
  
    <div class="label-container" >
      El PIN evita que personas no autorizadas firmen documentos en tu representación. Al ser personal e intransferible, <strong>te da acceso exclusivo a la opción de firma electrónica</strong>.
      <br><br>
      En resumen, el PIN añade una capa adicional de protección para prevenir que terceros usen tu firma electrónica.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 16) {
    <div class="image-container">
      <img src="../../../assets/iconografia/facturador.svg" />
    </div>
  
    <div class="label-container">
     <ul>
      <li>Intenta memorizarlo. Si necesitas respaldarlo, hazlo en un administrador de contraseñas o archivo digital protegido.
      </li>
      <li>No lo compartas con terceros. </li>
      <li>Evita ingresarlo en dispositivos desconocidos. Hazlo solo en equipos y redes de confianza.</li>
     </ul>
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 17) {
    <div class="label-container">

      <div class="box-info-facturas">
        <div class="titulo-facturas">Facturas de la simulación</div>

        <div class="container-facturas add_factoring">

          <div class="row" style="margin-bottom: 5px;">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Cantidad de facturas:</div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="font-weight: bold;text-align: right;">
              @if(loading_cantidad){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{cantidad_facturas}}
              }
            </div>

          </div>

          <div>
            <div style="text-align: right;">
              <mat-label class="pink-label" (click)="detalle_factura()">Abrir detalle <i
                  class="fa-solid fa-angle-right"></i></mat-label>
            </div>
          </div>

        </div>
      </div>

      <div class="box-info-facturas">
        <div class="titulo-facturas">Montos asociados</div>

        <div>
          <div class="row row-montos">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total simulado:</div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
              @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              ${{settings.formatMoney(monto_simulado)}}
              }
            </div>
          </div>
          <div class="row row-montos">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Porcentaje de financiamiento:</div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
              @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{porcentaje_financiamiento}}%
              }
            </div>
          </div>
          <div class="row row-montos">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto de anticipo:</div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
              @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              ${{settings.formatMoney(monto_anticipo)}}
              }
            </div>
          </div>
          <div class="row row-montos">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Vencimiento:</div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
              @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{dias_promedio}} días
              }
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 18) {
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>
  
    <div class="label-container" >
      Son facturas que evaluamos por adelantado tras vincularnos con tu perfil en el SII. Esto nos permite ofrecerte una opción de factoring inicial, personalizada e inmediata.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }@else if (step == 19) {
    <div class="img-center">
      <img src="../../../assets/img/Logo.png" />
    </div>
      
    <div class="label-container" >
      Podrás ceder tus facturas a través de esta plataforma. Solo tendrás que ingresar tus <span>credenciales del SII</span>.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }

  @else if(step == 90){

    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - Errorclavesii.svg" />
    </div>
  
    <div class="label-container">
      El RUT de empresa que ingresaste <strong>ya está registrado</strong> en Simpli.
      <br><br>
      Por seguridad, el RUT de una empresa puede ser registrado solo una vez. Para continuar con la creación de tu cuenta, 
          <strong>contacta a nuestro equipo de experiencia del cliente.</strong>
    </div>

  
    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" (click)="ir_a_ux()">Contactar con experiencia del cliente</button>
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="secondary-button" style="margin-right: 0px;" mat-dialog-close>Cerrar</button>
    </div>

  }

  @else if(step == 22){
    <div class="label-container">
      <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Escritura de constitución de la sociedad</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Se utiliza para <strong>crear una empresa</strong> (SpA, S.A o LTDA) y establecer los términos y condiciones de la sociedad, incluyendo razón social, objeto, capital, socios o accionistas y administración.
            <br><br>
            Si no cuentas con la escritura, <span class="clickable-text" (click)="open_modal_info(23)">descubre dónde obtenerla.</span>
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Extracto de la escritura de constitución</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Es un documento notarial que <strong>resume lo más importante de la escritura de constitución.</strong> Se utiliza para realizar la inscripción en el Registro de Comercio y la publicación en el Diario Oficial.
            <br><br>
            Puedes solicitar este documento en la notaría donde construiste la empresa.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Copia de la inscripción de constitución de sociedad</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Es la <strong>copia oficial de la inscripción</strong> de tu empresa en el Registro de Comercio. <br>
            Incluye información sobre la sociedad (notas, subinscripciones, etc).
            <br><br>
            Puedes solicitar este documento en el Conservador de Bienes Raíces donde constituiste la empresa.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Certificado de Vigencia de la sociedad</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Es el documento que <strong>confirma que la sociedad de la empresa sigue vigente.</strong><br>
            Puedes obtenerlo en el Conservador de Bienes Raíces de la comuna donde construiste la empresa.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Publicación en Diario Oficial</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Se refiere a la publicación del extracto de constitución en el Diario Oficial de la República de Chile.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Protocolización</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Es la recopilación del extracto de la escritura, la inscripción de constitución y la publicación en el Diario Oficial, todo <span class="clickable-text" (click)="open_modal_info(24)">protocolizado</span> en un mismo documento. 
            <br><br>
            Puedes solicitar este documento en la notaría donde constituiste la empresa.
          </p>
        </mat-expansion-panel>

      </mat-accordion>
      
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }

  @else if(step == 23){
    <div class="label-container">
      <ul>
        <li><strong>Escrituras con más de 1 año de antigüedad</strong>: Solicítala en el Archivo Judicial correspondiente a la notaría en donde se firmó o <span class="clickable-text" (click)="open_modal_info(24)">protocolizó</span> el documento.</li>
        <br>
        <li><strong>Escrituras con menos de 1 año de antigüedad</strong>: Solicítala en la notaría donde se firmó o protocolizó el documento.</li>
      </ul>  
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }

  @else if(step == 24){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>

    <div class="label-container">
      Es un proceso en donde se respalda legalmente un documento en el registro de un notario, para darle validez, autentificarlo o custodiarlo.
      <br><br>
      Esta medida se aplica a documentos físicos, como algunas escrituras de constitución de sociedades, contratos, entre otros.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }

  @else if(step == 25){
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - Upload file.png" />
    </div>

    <div class="label-container">
      Para que nuestra área legal pueda validar los documentos, debes cargar la <span class="clickable-text" (click)="open_modal_info(26)">última versión</span> de cada uno, con su <strong>información actualizada.</strong>
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" (click)="continue_documentacion()">Continuar</button>
    </div>
  }

  @else if(step == 26){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>

    <div class="label-container">
      Solicitar la última versión de los documentos nos garantiza que la información proporcionada es actual y refleja la situación legal vigente de la empresa.
      <br><br>
      Por otro lado, utilizar documentos desactualizados puede llevar a errores en la identificación de socios o poderes legales.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>
    </div>
  }

  @else if(step == 27){
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - calendar.png" />
    </div>

    <div class="label-container">
      Nuestra área legal <strong>deberá evaluar tu solicitud</strong> antes de realizar el cambio. Al iniciar el proceso, un ejecutivo te contactará para guiarte en cada paso.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" mat-dialog-close>Volver</button>
      <button mat-stroked-button class="secondary-button" (click)="continue_revision()">Continuar</button>
    </div>
  }

  @else if(step == 28){
    <div class="image-container">
      <img src="../../../assets/iconografia/Iconografia - legal.png" />
    </div>

    <div class="label-container">
      Ahora debes ingresar los datos de las personas que firmarán el contrato; si eres una de ellas, <strong>agrega el mismo correo</strong> que utilizaste para registrarte en la plataforma.

      <div class="box-info box-email">
        <strong>Correo que utilizaste:</strong> {{avalEmail}}
      </div>

      
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Aceptar</button>

    </div>
  }

  @else if(step == 29){
    <div class="label-container">

      <form [formGroup]="contactForm">
  
        <mat-form-field>
          <mat-label>Teléfono</mat-label>
          <input matInput type="text" maxlength="9" formControlName="telefono" required>
          <mat-hint>Ingresa el teléfono de la persona</mat-hint>
          <mat-error *ngIf="contactForm.controls['telefono'].hasError('required')">
            Teléfono es <strong>requerido</strong>
          </mat-error>
          <mat-error *ngIf="contactForm.controls['telefono'].hasError('pattern')">
            El número de teléfono debe ser de <strong>9 dígitos</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Correo electrónico</mat-label>
          <input matInput formControlName="email" type="email" required>
          <mat-hint>Ingresa el correo electrónico de la persona</mat-hint>
          <mat-error *ngIf="contactForm.get('email')?.hasError('email')">
            Por favor ingresa un correo electrónico válido
          </mat-error>
          <mat-error *ngIf="contactForm.get('email')?.hasError('required')">
            El correo electrónico es requerido
          </mat-error>
        </mat-form-field>
      </form>

      
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" [disabled]="!contactForm.valid" (click)="guardarDatosFirmante()">Guardar datos</button>

    </div>
  }

  @else if(step == 30){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>

    <div class="label-container">
      Para el caso de personas casadas bajo <strong>sociedad conyugal</strong>, la ley solicita que tanto ellas como sus cónyuges firmen el contrato. 
      <br><br>
      El objetivo es que ambas partes conozcan las condiciones del acuerdo, como medida de <strong>resguardo para los bienes compartidos</strong>.
    </div>

    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>

    </div>
  }

  @else if(step == 31){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>

    <div class="label-container">
      Es una <strong>proyección inicial</strong> de las condiciones (tasa, excedentes, etc) del financiamiento que recibirás al ceder tus facturas por cobrar.
      <br><br>
      Aún cuando la simulación es casi exacta, <strong>algunos datos podrían variar</strong> al operar. Si esto ocurre, podrás revisar el caso con un ejecutivo.
    </div>


    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>

    </div>
  }

  @else if(step == 32){

    <div class="box-info2" style="margin: 0 20px 20px 20px !important;">
      La firma de estos documentos es <strong>100% digital</strong> y aplica solo para las personas que actúan como <strong>representantes y/o apoderadas legales</strong> de la empresa.
    </div>

    <div class="label-container">
      <div class="titulo-facturas">Declaraciones legales</div>
      <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Declaración Jurada</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Sirve para informar quiénes son las personas que tienen el <strong>control, participan o se benefician económicamente</strong> de tu empresa.
            <br><br>
            Es una forma de asegurar transparencia y cumplir con normativas contra el lavado de dinero, financiamiento del terrorismo u otras infracciones.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Declaración PEP (Persona Expuesta Políticamente)</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Se utiliza para identificar si la persona que firma <strong>ocupa u ocupó un cargo público importante o destacado</strong>, o si tiene vínculos cercanos con alguien que lo hace.
            <br><br>
            Es importante para gestionar riesgos de corrupción o conflictos de interés.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Estado de Situación Financiera</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Permite evaluar la capacidad que tiene una persona o empresa para asumir compromisos financieros, como solicitar financiamiento o ser avalista, a través de la declaración de sus <strong>ingresos, deudas y patrimonio</strong>.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Rol de avalista, fiador y/o codeudor solidario</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Sirve para formalizar el compromiso del <strong>avalista, fiador y/o codeudor solidario</strong> de responder si la empresa no cumple con algún pago establecido en el contrato.
          </p>
        </mat-expansion-panel>

      </mat-accordion>

      <div class="titulo-facturas" style="margin-top: 30px;">Poderes legales</div>
      <mat-accordion>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Carta de poder</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Es donde se <strong>registra formalmente</strong> la cuenta bancaria a la cual debemos transferir el financiamiento.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Poder notarial</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Se utiliza en casos excepcionales donde se deben retirar pagos realizados con cheque o vale vista.
            <br><br>
            Por ejemplo, si una factura que nos cediste es pagada por el deudor (tu cliente) a través de un cheque o vale vista <strong>emitido a tu nombre por equivocación</strong>, este poder nos permitirá retirar ese pago. 
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>Poderes bancarios</mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Son poderes transversales <strong>solicitados por las instituciones bancarias</strong> para autorizar el retiro de un pago realizado con cheque o vale vista.
            <br><br>
            Mientras el Poder Notarial nos permite solicitar el pago, los poderes bancarios nos autorizan a retirarlo según las normativas de cada banco.
          </p>
        </mat-expansion-panel>

      </mat-accordion>
    </div>


    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>

    </div>
  }

  @else if(step == 33){
    <div class="image-container">
      <img src="../../../assets/iconografia/que-es-una-simulacion.svg" />
    </div>

    <div class="label-container">
      Son documentos que deberás firmar junto con el contrato para autorizarnos a transferir los montos de tus operaciones a la cuenta de tu empresa y realizar gestiones bancarias que serán especificadas en el set.
    </div>


    <div class="caja-botones">
      <button mat-stroked-button class="primary-button" style="margin-right: 0px;" mat-dialog-close>Volver</button>

    </div>
  }

</div>






